import { authIdParamName, resultParamName, resultParamPlaceholder } from '../external-auth-service';
/**
 * Encodes externalAuthRedirectUrl to be used as a query parameter passed to third party app servers for external authentication.
 * @returns URL-encoded externalAuthRedirectUrl string with "authId" and "result" query parameters
 */
export var getEncodedHostRedirectUrl = function (url, authId) {
    var redirectUrl = new URL(url);
    redirectUrl.searchParams.delete(authIdParamName);
    redirectUrl.searchParams.delete(resultParamName);
    // Provided query parameters will be single-encoded in result string, special characters must be double encoded if they are not meant to be replaced
    var search = decodeURIComponent(redirectUrl.searchParams.toString());
    var isSearchEmpty = search.trim() === '';
    redirectUrl.search = '';
    var existingQuery = "".concat(search).concat(isSearchEmpty ? '' : '&');
    return encodeURIComponent("".concat(redirectUrl.toString(), "?").concat(existingQuery).concat(authIdParamName, "=").concat(authId, "&").concat(resultParamName, "=").concat(resultParamPlaceholder));
};
//# sourceMappingURL=urlEncoding.js.map